import React, { useEffect, useState } from "react";
import axios from "axios";

import "./IgniteCustomers.css";

import CustomerStats from "./Components/CustomerStats";
import CustomerFilters from "./Components/CustomerFilters";
import CustomerTable from "./Components/CustomerTable";
import CustomerDrawer from "./Components/CustomerDrawer";

const IgniteCustomers = () => {

  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);

  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [levelFilter, setLevelFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  useEffect(() => {

    fetchCustomers();

  }, []);

  useEffect(() => {

    let data = [...customers];

    if (search.trim()) {

      data = data.filter((item) =>

        item.name
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||

        item.email
          ?.toLowerCase()
          .includes(search.toLowerCase())

      );

    }

    if (levelFilter !== "All") {

      data = data.filter(

        (item) =>

          item.currentLevel ===

          Number(levelFilter)

      );

    }

    if (statusFilter !== "All") {

      data = data.filter(

        (item) =>

          item.status === statusFilter

      );

    }

    setFilteredCustomers(data);

  }, [

    customers,

    search,

    levelFilter,

    statusFilter

  ]);

  const fetchCustomers = async () => {

    try {

      setLoading(true);

      const res = await axios.get(

        "/api/admin/ignite/customers"

      );

      if (res.data.success) {

        setCustomers(

          res.data.customers || []

        );

        setFilteredCustomers(

          res.data.customers || []

        );

      }

    }

    catch (err) {

      console.error(err);

    }

    finally {

      setLoading(false);

    }

  };

  return (

    <div className="ignite-customers">

      <div className="page-header">

        <div>

          <h1>

            Ignite Customers

          </h1>

          <p>

            Manage Vision Ignite members and journey.

          </p>

        </div>

      </div>

      <CustomerStats

        customers={customers}

      />

      <CustomerFilters

        search={search}
        setSearch={setSearch}

        levelFilter={levelFilter}
        setLevelFilter={setLevelFilter}

        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}

      />

      <CustomerTable

        loading={loading}

        customers={filteredCustomers}

        onView={(customer) => {

          setSelectedCustomer(customer);

          setDrawerOpen(true);

        }}

      />

      <CustomerDrawer

        open={drawerOpen}

        email={selectedCustomer?.email}

        onClose={() => {

          setDrawerOpen(false);

          setSelectedCustomer(null);

        }}

      />

    </div>

  );

};

export default IgniteCustomers;